import { CommonInsightsReportHelp } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightViews";
import { CommonInsightsDeploymentFailureRateOverview } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsDeploymentFailureRateViews";
export const InsightsReportDeploymentFailureRateHelp = () => (<>
        <CommonInsightsDeploymentFailureRateOverview /> <CommonInsightsReportHelp />
    </>);
